import { Component, ViewChild } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from '../../components/ionic2-super-tabs/src';
import { SuperTabsComponent } from '../../components/ionic2-super-tabs/src/components/super-tabs';

import { ReportCustomerClientPage } from "../report-customer-client/report-customer-client";
import { ReportSelectUnitPage } from "../report-select-unit/report-select-unit";
import { ReportFilesPage } from "../report-files/report-files";
import { ReportWorkorderPage } from "../report-workorder/report-workorder";
import { ReportMeasurementPage } from "../report-measurement/report-measurement";
import { ReportRepairsPage } from "../report-repairs/report-repairs";
import { ReportChecklistPage } from "../report-checklist/report-checklist";
import { ReportSubmitPage } from "../report-submit/report-submit";
import { ReportService } from "../../services/report.service";
import { ApiService } from "../../services/api.service";
import { DataService } from "../../services/data.service";

@Component({
  selector: 'page-report',
  templateUrl: 'report.html',
})
export class ReportPage {

  @ViewChild('mainTabs') superTabs: SuperTabsComponent;

  data: any;

  reportWorkorderPage = ReportWorkorderPage;
  reportCustomerClientPage = ReportCustomerClientPage;
  reportSelectUnitPage = ReportSelectUnitPage;
  reportFilesPage = ReportFilesPage;
  reportMeasurementPage = ReportMeasurementPage;
  reportRepairsPage = ReportRepairsPage;
  reportChecklistPage = ReportChecklistPage;
  reportSubmitPage = ReportSubmitPage;

  showAllTabs = true;
  hasRookgasmetingSubscription = false;

  tabs = [
    { page: ReportMeasurementPage, id: 'ReportMeasurementPage', caption: 'Rookgasmeting'},
    { page: ReportRepairsPage, id: 'ReportRepairsPage', caption: 'Interventies'},
    { page: ReportChecklistPage, id: 'ReportChecklistPage', caption: 'Checklist'},
  ];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController,
      public reportService: ReportService,
      public apiService: ApiService,
      public alertCtrl: AlertController,
      public dataService: DataService
  ) {
    this.data = this.reportService.getData();
    this.data._status = 'processing';
    if(!this.data._valid) this.data._valid = {};

    // Beperkte tabs als workorder_type Recyclage (4), Garantiekaart invullen (6)
    if(this.data.workorder_type == '4' || this.data.workorder_type == '6'){
      this.showAllTabs = false;
      this.data._valid.reportMeasurementPage = 1;
      this.data._valid.reportRepairsPage = 1;
      this.data._valid.reportChecklistPage = 1;
    }
    this.data._show_all_tabs = this.showAllTabs;

    if(this.data._has_invoice_customer == null){
      if(this.data.workorder_id && this.data.customers.invoice){
        this.data._has_invoice_customer = 1;
      } else {
        this.data._has_invoice_customer = 0;
      }
    }
    if(this.data._has_external_customer == null) {
      if (this.data.workorder_id && this.data.customers.external) {
        this.data._has_external_customer = 1;
      } else {
        this.data._has_external_customer = 0;
      }
    }

    // Migratie _selected_unit naar _selected_units (Verwijder in latere release)
    if(this.data._selected_units == null){
      this.data._selected_units = [];
      if(this.data._selected_unit){
        this.data._selected_units.push(this.data._selected_unit);
      }
    }

    // Notes alert weergeven
    if(this.data.notes){
      this.alertCtrl.create({
        title: 'Opmerking',
        message: this.data.notes,
        buttons: ['OK']
      }).present();
    }

    // Update brands
    this.dataService.updateUnitBrands().then(() => {}).catch(() => {});

    // Update devices
    this.dataService.updateDevices().then(() => {}).catch(() => {});

    // Update company_users
    this.dataService.updateCompanyUsers().then(() => {}).catch(() => {});
  }

  getTitle(){
    let title = 'Meten en rapporteren';
    switch(this.data.workorder_type){
      case '1':
        title = '1e inbedrijfstelling';
        break;
      case '2':
        title = 'Onderhoud';
        break;
      case '3':
        title = 'Storing';
        break;
      case '4':
        title = 'Toestel verwijderen';
        break;
      case '5':
        title = 'Aanmelden nieuwe installatie';
        break;
      case '6':
        title = 'Garantiekaart invullen';
        break;
      case '7':
        title = 'Buitenbedrijfstelling';
        break;
    }
    return title;
  }

  ngAfterViewInit() {
    // init tab colors
    if(this.data._valid.reportWorkorderPage === 1) this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_ok', 'mainTabs');
    if(this.data._valid.reportCustomerClientPage === 1) this.superTabsCtrl.setColor('reportCustomerClientPage', 'tab_ok', 'mainTabs');
    if(this.data._valid.reportSelectUnitPage === 1) this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_ok', 'mainTabs');
    if(this.showAllTabs){
      if(this.data._valid.reportMeasurementPage === 1) this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_ok', 'mainTabs');
      if(this.data._valid.reportRepairsPage === 1) this.superTabsCtrl.setColor('reportRepairsPage', 'tab_ok', 'mainTabs');
      if(this.data._valid.reportChecklistPage === 1) this.superTabsCtrl.setColor('reportChecklistPage', 'tab_ok', 'mainTabs');
    }

    if(this.data._valid.reportWorkorderPage === -1) this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_error', 'mainTabs');
    if(this.data._valid.reportCustomerExternalPage === -1) this.superTabsCtrl.setColor('reportCustomerExternalPage', 'tab_error', 'mainTabs');
    if(this.data._valid.reportSelectUnitPage === -1) this.superTabsCtrl.setColor('reportSelectUnitPage', 'tab_error', 'mainTabs');
    if(this.showAllTabs) {
      if (this.data._valid.reportMeasurementPage === -1) this.superTabsCtrl.setColor('reportMeasurementPage', 'tab_error', 'mainTabs');
      if (this.data._valid.reportRepairsPage === -1) this.superTabsCtrl.setColor('reportRepairsPage', 'tab_error', 'mainTabs');
      if (this.data._valid.reportChecklistPage === -1) this.superTabsCtrl.setColor('reportChecklistPage', 'tab_error', 'mainTabs');
    }
  }

  onTabSelect(tab: { index: number; id: string; }) {
    console.log(`Selected tab: `, tab);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportPage');
  }

  ionViewWillLeave(){
    console.log('ionViewWillLeave ReportPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report/report.ts